<template>
  <b-card class="card-company-table">
    <b-card-header>
      <h5>{{ title }}</h5>
    </b-card-header>
    <b-table
        :items="tableData"
        responsive
        :fields="fields"
        class="mb-0"
    />
  </b-card>
</template>

<script>
import {
  BCard, BTable, BCardHeader,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BCardHeader,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'گزارشات وظایف',
    },
  },

  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'عنوان',
        },
        {
          key: 'creator.name',
          label: 'ایجاد کننده',
        },
        {
          key: 'comments_count',
          label: 'تعداد نظر',
        },
      ],
    }
  },
  methods: {
    goToTicket() {
      this.$router.push('tasks/inbox')
    },
  },
}
</script>
